
import "./Css/ExamManagment.css";
import { useNavigate } from 'react-router-dom'
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";


const exams = [
  {
    id: 1,
    name: "सराव प्रश्नपत्रिका संच क्रमांक तीन",
    sudname: "आर्या पाटील",
    date: "१०-११-२०२५",
    amount: "₹५०",
    cumission: "₹५०",
   
  },
  {
    id: 2,
    name: "NMMS Exam",
    sudname: "सई देशमुख",
    date: "०६-११-२०२५",
    amount: "१०:०० AM",
    cumission: "₹५०",
  },
   {
    id: 3,
    name: "ज. नवोदय विद्यालय प्रवेश परीक्षा",
    sudname: "अन्वी जगताप",
    date: "०८-११-२०२५",
    amount: "₹४०",
    cumission: "₹५०",
   
  },
  {
    id: 4,
    name: "पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा",
    sudname: "प्रणव जाधव",
    date: "२०-१०-२०२५",
    amount: "₹६०",
    cumission: "₹५०",
   
  },
   {
    id: 5,
    name: "ज. नवोदय विद्यालय प्रवेश परीक्षा",
    sudname: "ईशा कदम",
    date: "२५-११-२०२५",
    amount: "₹७०",
    cumission: "₹५०",
   
  },
  {
    id: 6,
    name: "NMMS Exam",
    sudname: "अन्वी जगताप",
    date: "२५-११-२०२५",
    amount: "₹२४०",
    cumission: "₹५०",
   
  },
];

const BookManagement = () => {
   const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
      const [rowsPerPage, setRowsPerPage] = useState(5);
const [searchQuery, setSearchQuery] = useState('');
 const [examList, setExamList] = useState(exams);

  const handleViewClick = (index) => {
  navigate("/dashboard/bookview"); 
};
const handleRowClick = (exam) => {
  navigate("/dashboard/paymentdetail", {
    state: { exam }, 
  });
};


const filteredData = examList.filter((exam) =>
  exam.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
  exam.id.toString().includes(searchQuery)
);


const totalPages = Math.ceil(filteredData.length / rowsPerPage);

const paginatedData = filteredData.slice(
  (currentPage - 1) * rowsPerPage,
  currentPage * rowsPerPage
);
const location = useLocation();

  return (
    <div className="exam-page">
      {/* Header */}
      <div className="exam-header">
        <h3>पुस्तक व्यवस्थापन</h3>
        <div className="edit-btnn">
          <button className="btnc-outlinne" >
           एक्स्पोर्ट करा 
          </button>
         <button
  className="btnc-outlinne"
  onClick={() =>
    window.open(
      "https://akes.co.in/shop-books-educational-software-athravakunal-prakashan/",
      "_blank"
    )
  }
>
  पुस्तक खरेदी करा
</button>

        <button className="primary-btn" onClick={() => navigate("/dashboard/createbook")}>पुस्तक विक्री नोंद जोडा</button>

        </div>
      </div>
 <div className="filters">
<div className="search-wrapper-exam">
<svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
<path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484"/></svg>
<input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}/>
</div>
        <select>
          <option> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12.0011 18.6947L6.00113 15.4332V10.587L3.07812 9.0025L12.0011 4.15625L20.9241 9.0025V15.3872H19.9241V9.564L18.0011 10.587V15.4332L12.0011 18.6947ZM12.0011 12.7025L18.8319 9.0025L12.0011 5.3025L5.17038 9.0025L12.0011 12.7025ZM12.0011 17.5545L17.0011 14.8545V11.137L12.0011 13.845L7.00113 11.137V14.8545L12.0011 17.5545Z" fill="#616161"/>
</svg>महिना निवडा </option>
          <option>जानेवरी</option>
           <option>फेब्रुवारी</option>
            <option>मार्च</option>
        </select>
      </div>
      <div className="state">
        <div className="stats purple">
             <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
  <path d="M11.6343 35C10.7262 35 9.94898 34.6993 9.30259 34.0979C8.6562 33.4962 8.33301 32.7521 8.33301 31.8654V9.60917C8.33301 8.74583 8.62731 7.98833 9.21592 7.33667C9.80454 6.685 10.5305 6.26931 11.3938 6.08958L26.0255 3V27.3592L11.2593 30.5575C10.9237 30.6344 10.63 30.7878 10.378 31.0175C10.1258 31.2472 9.99967 31.5299 9.99967 31.8654C9.99967 32.299 10.162 32.6521 10.4868 32.9246C10.8115 33.1971 11.194 33.3333 11.6343 33.3333H29.9997V8.33333H31.6663V35H11.6343ZM12.3072 28.6508L13.9738 28.3046V7.26583L12.3072 7.61208V28.6508Z" fill="#8E63EF"/>
</svg></div>
        <div>
          <h4>एकूण विकलेली पुस्तके </h4>
          <p>120</p>
        </div>
      </div>
       <div className="stats green">
             <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
  <path d="M19.9997 20.6421C18.615 20.6421 17.4355 20.1551 16.4613 19.1809C15.4869 18.2064 14.9997 17.0269 14.9997 15.6421V11.0588C14.9997 10.5355 15.1786 10.0895 15.5363 9.72089C15.8944 9.35228 16.3352 9.16797 16.8588 9.16797C17.19 9.16797 17.4895 9.2438 17.7576 9.39547C18.0259 9.54714 18.2498 9.75019 18.4293 10.0046C18.6087 9.75019 18.8325 9.54714 19.1005 9.39547C19.3688 9.2438 19.6686 9.16797 19.9997 9.16797C20.3308 9.16797 20.6305 9.2438 20.8988 9.39547C21.1669 9.54714 21.3906 9.75019 21.5701 10.0046C21.7495 9.75019 21.9734 9.54714 22.2418 9.39547C22.5098 9.2438 22.8094 9.16797 23.1405 9.16797C23.6641 9.16797 24.105 9.35228 24.463 9.72089C24.8208 10.0895 24.9997 10.5355 24.9997 11.0588V15.6421C24.9997 17.0269 24.5125 18.2064 23.538 19.1809C22.5638 20.1551 21.3844 20.6421 19.9997 20.6421ZM8.33301 32.6938V29.9501C8.33301 29.262 8.53329 28.6182 8.93384 28.0188C9.33467 27.4196 9.8737 26.9544 10.5509 26.623C12.1237 25.8688 13.6975 25.3031 15.2722 24.9259C16.8469 24.5489 18.4227 24.3605 19.9997 24.3605C21.5766 24.3605 23.1525 24.5489 24.7272 24.9259C26.3019 25.3031 27.8757 25.8688 29.4484 26.623C30.1257 26.9544 30.6647 27.4196 31.0655 28.0188C31.4661 28.6182 31.6663 29.262 31.6663 29.9501V32.6938H8.33301Z" fill="#4A9C9C"/>
</svg></div>
        <div>
          <h4>पुस्तक खरेदी करणारे विद्यार्थी</h4>
          <p>८५</p>
        </div>
      </div>
       <div className="stats blue">
             <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
  <path d="M19.1441 34.1654V30.7745C17.7146 30.5906 16.4866 30.0959 15.4599 29.2904C14.4333 28.4848 13.6699 27.3705 13.1699 25.9474L14.7145 25.2745C15.1953 26.5223 15.8562 27.4827 16.697 28.1558C17.5378 28.8288 18.6784 29.1654 20.1187 29.1654C21.3856 29.1654 22.5431 28.8497 23.5912 28.2183C24.6392 27.5869 25.1633 26.5693 25.1633 25.1654C25.1633 23.9795 24.7776 23.027 24.0062 22.3079C23.2348 21.589 21.7915 20.8898 19.6762 20.2104C17.5223 19.5243 16.0063 18.7405 15.1283 17.8591C14.2499 16.9777 13.8108 15.8298 13.8108 14.4154C13.8108 12.8662 14.4048 11.629 15.5928 10.7037C16.7809 9.7787 17.9646 9.2787 19.1441 9.2037V5.83203H20.8108V9.2037C21.9646 9.31925 22.9556 9.63925 23.7837 10.1637C24.6117 10.6884 25.2981 11.4347 25.8428 12.4024L24.362 13.1591C23.9645 12.4411 23.4176 11.8598 22.7212 11.4154C22.0245 10.9709 21.1377 10.7487 20.0608 10.7487C18.7744 10.7487 17.689 11.089 16.8045 11.7695C15.9198 12.4501 15.4774 13.332 15.4774 14.4154C15.4774 15.439 15.8408 16.268 16.5674 16.9024C17.2938 17.5372 18.7488 18.1995 20.9324 18.8895C22.956 19.5306 24.4449 20.3538 25.3991 21.3591C26.353 22.3647 26.8299 23.627 26.8299 25.1462C26.8299 26.8193 26.2413 28.1483 25.0641 29.1333C23.8866 30.1183 22.4688 30.6718 20.8108 30.7937V34.1654H19.1441Z" fill="#4DA4E0"/>
</svg></div>
        <div>
          <h4>एकूण उत्पन्न </h4>
          <p>₹४८,५००/-</p>
        </div>
      </div>
      <div className="stats red">
             <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
  <path d="M12.6922 35C11.4869 35 10.4591 34.5747 9.60884 33.7242C8.75829 32.8739 8.33301 31.8461 8.33301 30.6408V10C8.33301 8.6025 8.81704 7.41986 9.78509 6.45208C10.7529 5.48403 11.9355 5 13.333 5H31.6663V27.9488C30.9291 27.9488 30.2961 28.2132 29.7672 28.7421C29.2383 29.271 28.9738 29.9039 28.9738 30.6408C28.9738 31.3781 29.2383 32.0111 29.7672 32.54C30.2961 33.0689 30.9291 33.3333 31.6663 33.3333V35H12.6922ZM13.9738 26.2821H15.6405V6.66667H13.9738V26.2821ZM12.6922 33.3333H28.2976C27.9815 32.9658 27.7375 32.5593 27.5655 32.1138C27.3933 31.6682 27.3072 31.1772 27.3072 30.6408C27.3072 30.1325 27.3916 29.6486 27.5605 29.1892C27.7294 28.7297 27.9751 28.3163 28.2976 27.9488H12.6922C11.9272 27.9488 11.2872 28.2132 10.7722 28.7421C10.2572 29.271 9.99967 29.9039 9.99967 30.6408C9.99967 31.4058 10.2572 32.0458 10.7722 32.5608C11.2872 33.0758 11.9272 33.3333 12.6922 33.3333Z" fill="#E15756"/>
</svg></div>
        <div>
          <h4>कमिशन</h4>
          <p>₹४,५००/-</p>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg"  style={{ cursor: "pointer" }}
      onClick={() => navigate("/dashboard/commissiondetail")} width="12" height="20" viewBox="0 0 12 20" fill="none">
  <path d="M1.775 20L0 18.225L8.225 10L0 1.775L1.775 0L11.775 10L1.775 20Z" fill="white"/>
</svg>
      </div>
      </div>

      {/* Table */}
      <div className="table-card">
        <table>
          <thead>
            <tr>
              <th>क्र.</th>
              <th>पुस्तकाचं नाव</th>
              <th>विद्यार्थ्याचं नाव </th>
              <th>पेमेंट तारीख</th>
              <th>किंमत ₹</th>
              <th>कमिशन %</th>
              <th>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((exam, index) => (
     <tr
      key={exam.id}
      onClick={() => handleRowClick(exam)}
      style={{ cursor: "pointer" }}
    >
                <td>{index + 1}</td>
                <td>{exam.name}</td>
                <td>{exam.sudname}</td>
                <td>{exam.date}</td>
                <td>{exam.amount}</td>
                <td>{exam.cumission}</td>
                  <td className="actions">
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleViewClick(index)}  width="20" height="20" viewBox="0 0 24 24" fill="none">
  <path d="M12.0037 15.1538C13.0198 15.1538 13.8821 14.7981 14.5904 14.0868C15.2988 13.3754 15.6529 12.5117 15.6529 11.4955C15.6529 10.4793 15.2973 9.61708 14.5859 8.90875C13.8746 8.20042 13.0108 7.84625 11.9947 7.84625C10.9785 7.84625 10.1163 8.20192 9.40792 8.91325C8.69959 9.62458 8.34542 10.4883 8.34542 11.5045C8.34542 12.5207 8.70109 13.3829 9.41242 14.0913C10.1238 14.7996 10.9875 15.1538 12.0037 15.1538ZM11.9992 14.2C11.2492 14.2 10.6117 13.9375 10.0867 13.4125C9.56167 12.8875 9.29917 12.25 9.29917 11.5C9.29917 10.75 9.56167 10.1125 10.0867 9.5875C10.6117 9.0625 11.2492 8.8 11.9992 8.8C12.7492 8.8 13.3867 9.0625 13.9117 9.5875C14.4367 10.1125 14.6992 10.75 14.6992 11.5C14.6992 12.25 14.4367 12.8875 13.9117 13.4125C13.3867 13.9375 12.7492 14.2 11.9992 14.2ZM12.0019 18C9.83592 18 7.86192 17.4106 6.07992 16.2317C4.29792 15.0529 2.96334 13.4757 2.07617 11.5C2.96334 9.52433 4.29701 7.94708 6.07717 6.76825C7.85734 5.58942 9.83042 5 11.9964 5C14.1624 5 16.1364 5.58942 17.9184 6.76825C19.7004 7.94708 21.035 9.52433 21.9222 11.5C21.035 13.4757 19.7013 15.0529 17.9212 16.2317C16.141 17.4106 14.1679 18 12.0019 18Z" fill="#313030"/>
</svg> 
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
     <div className='que-pagination-container'>
      <div className="que-pagination-controlss">
        <button
          className="que-pagination-btn"
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
         &lt;
        </button>

        {[...Array(totalPages).keys()]
          .map((_, i) => i + 1)
          .slice(
            Math.max(currentPage - 2, 0),
            Math.min(currentPage + 1, totalPages)
          )
          .map((page) => (
            <button
              key={page}
              className={`que-pagination-btn ${
                currentPage === page ? 'active' : ''
              }`}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          ))}

        <button
          className="que-pagination-btn"
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
        >
           &gt;
        </button>
         {/* Rows per page and range info */}
      <div className="que-pagination-controls">
        <span className="que-rows-label">Rows per page:</span>
        <select
          value={rowsPerPage}
          onChange={(e) => {
            setRowsPerPage(Number(e.target.value));
            setCurrentPage(1);
          }}
          className="que-rows-dropdown"
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
          <option value={20}>20</option>
        </select>
</div>
      </div>
</div>
    </div>
  );
};

export default BookManagement;
